// // import React, { useState, useEffect } from 'react';
// // import { FaSave, FaUpload, FaPlus, FaTrash, FaEdit } from 'react-icons/fa';

// // const AdminOfferPanel = () => {
// //   // Stan dla danych oferty
// //   const [offerData, setOfferData] = useState({
// //     title: "Nasza oferta",
// //     domki: {
// //       title: "DOMKI 4-6 osobowe",
// //       image: "/images/oferta4.jpg",
// //       shortDescription: "Oferujemy Państwu piętrowe kolorowe drewniane domki, w pełni wyposażone. W domku spokojnie może zamieszkać rodzina 4-6 osobowa.",
// //       galleryImages: [
// //         { id: 1, src: '/images/oferta1.jpg' },
// //         { id: 2, src: '/images/oferta3.jpg' },
// //         { id: 3, src: '/images/oferta4.jpg' },
// //         { id: 4, src: '/images/oferta5.png' }
// //       ],
// //       fullDescription: {
// //         amenities: [
// //           "Parking, 1 miejsce parkingowe na domek",
// //           "Atrakcyjny plac zabaw dla dzieci na ogrodzonym terenie",
// //           "Miejsce do grillowania",
// //           "Internet bezprzewodowy WiFi",
// //           "Kijki do Nordic Walking",
// //           "Kojec dla dzieci - udostępniamy na życzenie Gości"
// //         ],
// //         parter: {
// //           kuchenny: [
// //             "Lodówka podblatowa",
// //             "Kuchenka elektryczna 2 palnikowa",
// //             "Mikrofalówka, czajnik",
// //             "Komplet garnków, patelnia",
// //             "Komplet talerzy i sztućców dla 6 osób",
// //             "Zlewozmywak"
// //           ],
// //           lazienka: [
// //             "Kabina prysznicowa",
// //             "Umywalka z szafką",
// //             "Kompakt WC",
// //             "Szafka, lustro, suszarka do włosów"
// //           ],
// //           dzienny: [
// //             "Sofa z funkcją spania dla 2 osób",
// //             "Stolik kawowy i TV",
// //             "Składany stolik z krzesłami",
// //             "Telewizor LCD 22 calowy z TV SAT",
// //             "Szafa"
// //           ],
// //           taras: "Taras ze stołem i krzesłami"
// //         },
// //         pietro: {
// //           sypialnia: [
// //             "2 łóżka pojedyncze oraz jedno podwójne",
// //             "Komoda",
// //             "Lampka nocna"
// //           ]
// //         },
// //         dodatkowe: "Każdy domek wyposażony w parawan na plażę, 2 leżaki oraz koc."
// //       }
// //     },
// //     apartamenty: {
// //       title: "APARTAMENTY KOLOROWE DOMKI",
// //       image: "/images/ofertadeluxe2.jpg",
// //       shortDescription: "Oferujemy Państwu piętrowe, komfortowe i w pełni wyposażone apartamenty z 2 sypialniami. W apartamencie może zamieszkać rodzina 4-8 osobowa.",
// //       galleryImages: [
// //         { id: 1, src: '/images/ofertadeluxe1.jpg' },
// //         { id: 2, src: '/images/ofertadeluxe2.jpg' },
// //         { id: 3, src: '/images/ofertadeluxe3.jpg' },
// //         { id: 4, src: '/images/ofertadeluxe4.jpg' },
// //         { id: 5, src: '/images/ofertadeluxe5.jpg' }
// //       ],
// //       fullDescription: {
// //         amenities: [
// //           "Parking",
// //           "Atrakcyjny plac zabaw dla dzieci na ogrodzonym terenie",
// //           "Duży teren zielony do wypoczynku z hamakami i leżakami",
// //           "Kameralną atmosferę, tylko 3 apartamenty na działce",
// //           "Miejsce do grillowania",
// //           "Internet bezprzewodowy WiFi",
// //           "Kijki do Nordic Walking",
// //           "Kojec dla dzieci - udostępniamy na życzenie Gości"
// //         ],
// //         parter: {
// //           kuchenny: [
// //             "Lodówka z zamrażarką",
// //             "Kuchenka elektryczna 4-palnikowa",
// //             "Zmywarka i zlewozmywak",
// //             "Mikrofalówka, czajnik i ekspres do kawy Tchibo Cafissimo na kapsułki",
// //             "Komplet garnków i patelni",
// //             "Komplet talerzy i sztućców dla 8 osób"
// //           ],
// //           lazienka: [
// //             "Kabina prysznicowa",
// //             "Umywalka z szafką",
// //             "Kompakt WC",
// //             "Lustro, wieszaki, suszarka do włosów"
// //           ],
// //           salon: [
// //             "Narożnik z funkcją spania dla 2 osób",
// //             "Stolik kawowy",
// //             "Szafka",
// //             "Telewizor LCD 32 calowy z TV SAT",
// //             "Duży stół dla 4-8 osób",
// //             "Taras ze stołem i krzesłami"
// //           ]
// //         },
// //         pietro: {
// //           sypialnia1: [
// //             "1 łóżko pojedyncze oraz jedno podwójne",
// //             "Szafa",
// //             "Półki i lampki nocne",
// //             "Balkon z widokiem na las"
// //           ],
// //           sypialnia2: [
// //             "3 łóżka pojedyncze",
// //             "Komoda",
// //             "Półki i lampki nocne"
// //           ]
// //         },
// //         dodatkowe: "Każdy domek wyposażony w parawan na plażę, 2 leżaki oraz koc."
// //       }
// //     }
// //   });

// //   const [message, setMessage] = useState("");
// //   const [imageUploading, setImageUploading] = useState({});
// //   const [editingSection, setEditingSection] = useState(null);
// //   const [editingCategory, setEditingCategory] = useState(null);

// //   // Załaduj dane z localStorage przy starcie
// //   useEffect(() => {
// //     const savedData = localStorage.getItem('offerData');
// //     if (savedData) {
// //       setOfferData(JSON.parse(savedData));
// //     }
// //   }, []);

// //   const saveData = () => {
// //     localStorage.setItem('offerData', JSON.stringify(offerData));
// //     setMessage("Zmiany zapisane pomyślnie!");
// //     setTimeout(() => setMessage(""), 3000);
// //   };

// //   const handleImageUpload = (e, section, field) => {
// //     const file = e.target.files[0];
// //     if (file) {
// //       setImageUploading({ ...imageUploading, [section]: true });
      
// //       // Symulacja procesu uploadu
// //       setTimeout(() => {
// //         const reader = new FileReader();
// //         reader.onload = (event) => {
// //           const newImageUrl = event.target.result;
// //           if (section === 'general') {
// //             setOfferData({
// //               ...offerData,
// //               [field]: newImageUrl
// //             });
// //           } else {
// //             setOfferData({
// //               ...offerData,
// //               [section]: {
// //                 ...offerData[section],
// //                 [field]: newImageUrl
// //               }
// //             });
// //           }
// //           setImageUploading({ ...imageUploading, [section]: false });
// //         };
// //         reader.readAsDataURL(file);
// //       }, 1000);
// //     }
// //   };

// //   const handleGalleryImageUpload = (e, section, index = null) => {
// //     const file = e.target.files[0];
// //     if (file) {
// //       const uploadKey = `${section}-gallery`;
// //       setImageUploading({ ...imageUploading, [uploadKey]: true });
      
// //       setTimeout(() => {
// //         const reader = new FileReader();
// //         reader.onload = (event) => {
// //           const newImageUrl = event.target.result;
// //           const newImage = { 
// //             id: Date.now(), 
// //             src: newImageUrl 
// //           };
          
// //           setOfferData({
// //             ...offerData,
// //             [section]: {
// //               ...offerData[section],
// //               galleryImages: index !== null 
// //                 ? offerData[section].galleryImages.map((img, i) => i === index ? newImage : img)
// //                 : [...offerData[section].galleryImages, newImage]
// //             }
// //           });
// //           setImageUploading({ ...imageUploading, [uploadKey]: false });
// //         };
// //         reader.readAsDataURL(file);
// //       }, 1000);
// //     }
// //   };

// //   const removeGalleryImage = (section, index) => {
// //     setOfferData({
// //       ...offerData,
// //       [section]: {
// //         ...offerData[section],
// //         galleryImages: offerData[section].galleryImages.filter((_, i) => i !== index)
// //       }
// //     });
// //   };

// //   const handleTextChange = (section, field, value) => {
// //     if (section === 'general') {
// //       setOfferData({
// //         ...offerData,
// //         [field]: value
// //       });
// //     } else {
// //       setOfferData({
// //         ...offerData,
// //         [section]: {
// //           ...offerData[section],
// //           [field]: value
// //         }
// //       });
// //     }
// //   };

// //   const handleArrayItemChange = (section, category, index, value) => {
// //     const updatedArray = [...offerData[section].fullDescription[category]];
// //     updatedArray[index] = value;
    
// //     setOfferData({
// //       ...offerData,
// //       [section]: {
// //         ...offerData[section],
// //         fullDescription: {
// //           ...offerData[section].fullDescription,
// //           [category]: updatedArray
// //         }
// //       }
// //     });
// //   };

// //   const addArrayItem = (section, category) => {
// //     setOfferData({
// //       ...offerData,
// //       [section]: {
// //         ...offerData[section],
// //         fullDescription: {
// //           ...offerData[section].fullDescription,
// //           [category]: [...offerData[section].fullDescription[category], ""]
// //         }
// //       }
// //     });
// //   };

// //   const removeArrayItem = (section, category, index) => {
// //     setOfferData({
// //       ...offerData,
// //       [section]: {
// //         ...offerData[section],
// //         fullDescription: {
// //           ...offerData[section].fullDescription,
// //           [category]: offerData[section].fullDescription[category].filter((_, i) => i !== index)
// //         }
// //       }
// //     });
// //   };

// //   const startEditing = (section, category = null) => {
// //     setEditingSection(section);
// //     setEditingCategory(category);
// //   };

// //   const stopEditing = () => {
// //     setEditingSection(null);
// //     setEditingCategory(null);
// //   };

// //   const renderEditableList = (section, category, title) => (
// //     <div className="mb-4">
// //       <h4 className="font-semibold mb-2">{title}</h4>
// //       {offerData[section].fullDescription[category].map((item, index) => (
// //         <div key={index} className="flex items-center gap-2 mb-2">
// //           <input
// //             type="text"
// //             value={item}
// //             onChange={(e) => handleArrayItemChange(section, category, index, e.target.value)}
// //             className="flex-1 p-2 border border-gray-300 rounded-md"
// //           />
// //           <button
// //             onClick={() => removeArrayItem(section, category, index)}
// //             className="p-2 bg-red-100 text-red-600 rounded-md"
// //           >
// //             <FaTrash />
// //           </button>
// //         </div>
// //       ))}
// //       <button
// //         onClick={() => addArrayItem(section, category)}
// //         className="flex items-center gap-2 bg-blue-500 text-white px-3 py-1 rounded-md text-sm"
// //       >
// //         <FaPlus /> Dodaj pozycję
// //       </button>
// //     </div>
// //   );

// //   const renderImageUpload = (label, section, field, isGallery = false, index = null) => (
// //     <div className="mb-4">
// //       <label className="block text-sm font-medium text-gray-700 mb-2">{label}</label>
// //       <div className="flex items-center gap-4">
// //         <div className="w-20 h-20 bg-gray-200 rounded-md overflow-hidden">
// //           <img 
// //             src={isGallery ? offerData[section].galleryImages[index]?.src : offerData[section][field]} 
// //             alt="Podgląd" 
// //             className="w-full h-full object-cover"
// //           />
// //         </div>
// //         <label className="flex flex-col items-center justify-center w-full h-32 border-2 border-dashed border-gray-300 rounded-md cursor-pointer bg-gray-50 hover:bg-gray-100">
// //           {imageUploading[`${section}${isGallery ? '-gallery' : ''}`] ? (
// //             <div className="flex flex-col items-center justify-center">
// //               <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500 mb-2"></div>
// //               <span className="text-sm">Przesyłanie...</span>
// //             </div>
// //           ) : (
// //             <>
// //               <FaUpload className="w-8 h-8 text-gray-500 mb-2" />
// //               <p className="text-sm text-gray-500 text-center">
// //                 <span className="font-semibold">Kliknij aby przesłać</span><br />
// //                 <span className="text-xs">PNG, JPG (max. 5MB)</span>
// //               </p>
// //               <input 
// //                 type="file" 
// //                 className="hidden" 
// //                 onChange={(e) => isGallery ? handleGalleryImageUpload(e, section, index) : handleImageUpload(e, section, field)} 
// //                 accept="image/*" 
// //               />
// //             </>
// //           )}
// //         </label>
// //       </div>
// //     </div>
// //   );

// //   return (
// //     <div className="min-h-screen bg-gray-100 p-6">
// //       <div className="max-w-6xl mx-auto bg-white rounded-lg shadow-md p-6">
// //         <h1 className="text-2xl font-bold mb-6 text-gray-800">Panel Administracyjny - Sekcja Oferta</h1>
        
// //         {message && (
// //           <div className="mb-4 p-3 bg-green-100 text-green-700 rounded">
// //             {message}
// //           </div>
// //         )}
        
// //         {/* Nagłówek sekcji */}
// //         <div className="mb-8 p-4 border border-gray-200 rounded-md">
// //           <h2 className="text-lg font-semibold mb-3">Nagłówek sekcji</h2>
// //           <div className="mb-4">
// //             <label className="block text-sm font-medium text-gray-700 mb-2">Tytuł sekcji</label>
// //             <input
// //               type="text"
// //               value={offerData.title}
// //               onChange={(e) => handleTextChange('general', 'title', e.target.value)}
// //               className="w-full p-3 border border-gray-300 rounded-md"
// //             />
// //           </div>
// //         </div>

// //         {/* Domki */}
// //         <div className="mb-8 p-4 border border-gray-200 rounded-md">
// //           <h2 className="text-lg font-semibold mb-3">Domki 4-6 osobowe</h2>
          
// //           <div className="mb-4">
// //             <label className="block text-sm font-medium text-gray-700 mb-2">Tytuł</label>
// //             <input
// //               type="text"
// //               value={offerData.domki.title}
// //               onChange={(e) => handleTextChange('domki', 'title', e.target.value)}
// //               className="w-full p-3 border border-gray-300 rounded-md"
// //             />
// //           </div>
          
// //           {renderImageUpload("Główne zdjęcie", "domki", "image")}
          
// //           <div className="mb-4">
// //             <label className="block text-sm font-medium text-gray-700 mb-2">Krótki opis</label>
// //             <textarea
// //               value={offerData.domki.shortDescription}
// //               onChange={(e) => handleTextChange('domki', 'shortDescription', e.target.value)}
// //               className="w-full p-3 border border-gray-300 rounded-md h-32"
// //             />
// //           </div>
          
// //           <div className="mb-4">
// //             <h3 className="font-semibold mb-2">Galeria zdjęć</h3>
// //             <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-4">
// //               {offerData.domki.galleryImages.map((img, index) => (
// //                 <div key={img.id} className="relative group">
// //                   <img src={img.src} alt={`Domki ${index + 1}`} className="w-full h-20 object-cover rounded-md" />
// //                   <button
// //                     onClick={() => removeGalleryImage('domki', index)}
// //                     className="absolute top-1 right-1 bg-red-500 text-white p-1 rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
// //                   >
// //                     <FaTrash size={12} />
// //                   </button>
// //                   <div className="mt-2">
// //                     <label className="flex items-center justify-center w-full h-8 border border-dashed border-gray-300 rounded-md cursor-pointer bg-gray-50 hover:bg-gray-100 text-xs">
// //                       Zmień
// //                       <input 
// //                         type="file" 
// //                         className="hidden" 
// //                         onChange={(e) => handleGalleryImageUpload(e, 'domki', index)} 
// //                         accept="image/*" 
// //                       />
// //                     </label>
// //                   </div>
// //                 </div>
// //               ))}
// //             </div>
// //             <label className="flex items-center justify-center w-full h-32 border-2 border-dashed border-gray-300 rounded-md cursor-pointer bg-gray-50 hover:bg-gray-100">
// //               <FaPlus className="w-6 h-6 text-gray-500 mr-2" />
// //               <span>Dodaj zdjęcie do galerii</span>
// //               <input 
// //                 type="file" 
// //                 className="hidden" 
// //                 onChange={(e) => handleGalleryImageUpload(e, 'domki')} 
// //                 accept="image/*" 
// //               />
// //             </label>
// //           </div>
          
// //           <div className="mb-4">
// //             <h3 className="font-semibold mb-2">Pełny opis</h3>
            
// //             {renderEditableList('domki', 'amenities', 'Udogodnienia')}
// //             {renderEditableList('domki', 'parter.kuchenny', 'Aneks kuchenny (Parter)')}
// //             {renderEditableList('domki', 'parter.lazienka', 'Łazienka (Parter)')}
// //             {renderEditableList('domki', 'parter.dzienny', 'Pokój dzienny (Parter)')}
            
// //             <div className="mb-4">
// //               <h4 className="font-semibold mb-2">Taras (Parter)</h4>
// //               <input
// //                 type="text"
// //                 value={offerData.domki.fullDescription.parter.taras}
// //                 onChange={(e) => handleTextChange('domki', 'fullDescription.parter.taras', e.target.value)}
// //                 className="w-full p-2 border border-gray-300 rounded-md"
// //               />
// //             </div>
            
// //             {renderEditableList('domki', 'pietro.sypialnia', 'Sypialnia (Piętro)')}
            
// //             <div className="mb-4">
// //               <h4 className="font-semibold mb-2">Dodatkowe informacje</h4>
// //               <input
// //                 type="text"
// //                 value={offerData.domki.fullDescription.dodatkowe}
// //                 onChange={(e) => handleTextChange('domki', 'fullDescription.dodatkowe', e.target.value)}
// //                 className="w-full p-2 border border-gray-300 rounded-md"
// //               />
// //             </div>
// //           </div>
// //         </div>

// //         {/* Apartamenty */}
// //         <div className="mb-8 p-4 border border-gray-200 rounded-md">
// //           <h2 className="text-lg font-semibold mb-3">Apartamenty Kolorowe Domki</h2>
          
// //           <div className="mb-4">
// //             <label className="block text-sm font-medium text-gray-700 mb-2">Tytuł</label>
// //             <input
// //               type="text"
// //               value={offerData.apartamenty.title}
// //               onChange={(e) => handleTextChange('apartamenty', 'title', e.target.value)}
// //               className="w-full p-3 border border-gray-300 rounded-md"
// //             />
// //           </div>
          
// //           {renderImageUpload("Główne zdjęcie", "apartamenty", "image")}
          
// //           <div className="mb-4">
// //             <label className="block text-sm font-medium text-gray-700 mb-2">Krótki opis</label>
// //             <textarea
// //               value={offerData.apartamenty.shortDescription}
// //               onChange={(e) => handleTextChange('apartamenty', 'shortDescription', e.target.value)}
// //               className="w-full p-3 border border-gray-300 rounded-md h-32"
// //             />
// //           </div>
          
// //           <div className="mb-4">
// //             <h3 className="font-semibold mb-2">Galeria zdjęć</h3>
// //             <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-4">
// //               {offerData.apartamenty.galleryImages.map((img, index) => (
// //                 <div key={img.id} className="relative group">
// //                   <img src={img.src} alt={`Apartamenty ${index + 1}`} className="w-full h-20 object-cover rounded-md" />
// //                   <button
// //                     onClick={() => removeGalleryImage('apartamenty', index)}
// //                     className="absolute top-1 right-1 bg-red-500 text-white p-1 rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
// //                   >
// //                     <FaTrash size={12} />
// //                   </button>
// //                   <div className="mt-2">
// //                     <label className="flex items-center justify-center w-full h-8 border border-dashed border-gray-300 rounded-md cursor-pointer bg-gray-50 hover:bg-gray-100 text-xs">
// //                       Zmień
// //                       <input 
// //                         type="file" 
// //                         className="hidden" 
// //                         onChange={(e) => handleGalleryImageUpload(e, 'apartamenty', index)} 
// //                         accept="image/*" 
// //                       />
// //                     </label>
// //                   </div>
// //                 </div>
// //               ))}
// //             </div>
// //             <label className="flex items-center justify-center w-full h-32 border-2 border-dashed border-gray-300 rounded-md cursor-pointer bg-gray-50 hover:bg-gray-100">
// //               <FaPlus className="w-6 h-6 text-gray-500 mr-2" />
// //               <span>Dodaj zdjęcie do galerii</span>
// //               <input 
// //                 type="file" 
// //                 className="hidden" 
// //                 onChange={(e) => handleGalleryImageUpload(e, 'apartamenty')} 
// //                 accept="image/*" 
// //               />
// //             </label>
// //           </div>
          
// //           <div className="mb-4">
// //             <h3 className="font-semibold mb-2">Pełny opis</h3>
            
// //             {renderEditableList('apartamenty', 'amenities', 'Udogodnienia')}
// //             {renderEditableList('apartamenty', 'parter.kuchenny', 'Aneks kuchenny (Parter)')}
// //             {renderEditableList('apartamenty', 'parter.lazienka', 'Łazienka (Parter)')}
// //             {renderEditableList('apartamenty', 'parter.salon', 'Salon (Parter)')}
// //             {renderEditableList('apartamenty', 'pietro.sypialnia1', 'Sypialnia 1 (Piętro)')}
// //             {renderEditableList('apartamenty', 'pietro.sypialnia2', 'Sypialnia 2 (Piętro)')}
            
// //             <div className="mb-4">
// //               <h4 className="font-semibold mb-2">Dodatkowe informacje</h4>
// //               <input
// //                 type="text"
// //                 value={offerData.apartamenty.fullDescription.dodatkowe}
// //                 onChange={(e) => handleTextChange('apartamenty', 'fullDescription.dodatkowe', e.target.value)}
// //                 className="w-full p-2 border border-gray-300 rounded-md"
// //               />
// //             </div>
// //           </div>
// //         </div>

// //         {/* Zapisywanie */}
// //         <div className="flex justify-end">
// //           <button
// //             onClick={saveData}
// //             className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-medium py-2 px-4 rounded-md"
// //           >
// //             <FaSave /> Zapisz zmiany
// //           </button>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default AdminOfferPanel;

// import React, { useState, useEffect } from 'react';
// import { FaSave, FaUpload, FaPlus, FaTrash } from 'react-icons/fa';

// const AdminOfferPanel = () => {
//   const [offerData, setOfferData] = useState({
//     title: "Nasza oferta",
//     domki: {
//       title: "DOMKI 4-6 osobowe",
//       image: "/images/oferta4.jpg",
//       shortDescription: "Oferujemy Państwu piętrowe kolorowe drewniane domki, w pełni wyposażone. W domku spokojnie może zamieszkać rodzina 4-6 osobowa.",
//       galleryImages: [
//         { id: 1, src: '/images/oferta1.jpg' },
//         { id: 2, src: '/images/oferta3.jpg' },
//         { id: 3, src: '/images/oferta4.jpg' },
//         { id: 4, src: '/images/oferta5.png' }
//       ],
//       fullDescription: {
//         amenities: [
//           "Parking, 1 miejsce parkingowe na domek",
//           "Atrakcyjny plac zabaw dla dzieci na ogrodzonym terenie",
//           "Miejsce do grillowania",
//           "Internet bezprzewodowy WiFi",
//           "Kijki do Nordic Walking",
//           "Kojec dla dzieci - udostępniamy na życzenie Gości"
//         ],
//         parter: {
//           kuchenny: [
//             "Lodówka podblatowa",
//             "Kuchenka elektryczna 2 palnikowa",
//             "Mikrofalówka, czajnik",
//             "Komplet garnków, patelnia",
//             "Komplet talerzy i sztućców dla 6 osób",
//             "Zlewozmywak"
//           ],
//           lazienka: [
//             "Kabina prysznicowa",
//             "Umywalka z szafką",
//             "Kompakt WC",
//             "Szafka, lustro, suszarka do włosów"
//           ],
//           dzienny: [
//             "Sofa z funkcją spania dla 2 osób",
//             "Stolik kawowy i TV",
//             "Składany stolik z krzesłami",
//             "Telewizor LCD 22 calowy z TV SAT",
//             "Szafa"
//           ],
//           taras: "Taras ze stołem i krzesłami"
//         },
//         pietro: {
//           sypialnia: [
//             "2 łóżka pojedyncze oraz jedno podwójne",
//             "Komoda",
//             "Lampka nocna"
//           ]
//         },
//         dodatkowe: "Każdy domek wyposażony w parawan na plażę, 2 leżaki oraz koc."
//       }
//     },
//     apartamenty: {
//       title: "APARTAMENTY KOLOROWE DOMKI",
//       image: "/images/ofertadeluxe2.jpg",
//       shortDescription: "Oferujemy Państwu piętrowe, komfortowe i w pełni wyposażone apartamenty z 2 sypialniami. W apartamencie może zamieszkać rodzina 4-8 osobowa.",
//       galleryImages: [
//         { id: 1, src: '/images/ofertadeluxe1.jpg' },
//         { id: 2, src: '/images/ofertadeluxe2.jpg' },
//         { id: 3, src: '/images/ofertadeluxe3.jpg' },
//         { id: 4, src: '/images/ofertadeluxe4.jpg' },
//         { id: 5, src: '/images/ofertadeluxe5.jpg' }
//       ],
//       fullDescription: {
//         amenities: [
//           "Parking",
//           "Atrakcyjny plac zabaw dla dzieci na ogrodzonym terenie",
//           "Duży teren zielony do wypoczynku z hamakami i leżakami",
//           "Kameralną atmosferę, tylko 3 apartamenty na działce",
//           "Miejsce do grillowania",
//           "Internet bezprzewodowy WiFi",
//           "Kijki do Nordic Walking",
//           "Kojec dla dzieci - udostępniamy na życzenie Gości"
//         ],
//         parter: {
//           kuchenny: [
//             "Lodówka z zamrażarką",
//             "Kuchenka elektryczna 4-palnikowa",
//             "Zmywarka i zlewozmywak",
//             "Mikrofalówka, czajnik i ekspres do kawy Tchibo Cafissimo na kapsułki",
//             "Komplet garnków i patelni",
//             "Komplet talerzy i sztućców dla 8 osób"
//           ],
//           lazienka: [
//             "Kabina prysznicowa",
//             "Umywalka z szafką",
//             "Kompakt WC",
//             "Lustro, wieszaki, suszarka do włosów"
//           ],
//           salon: [
//             "Narożnik z funkcją spania dla 2 osób",
//             "Stolik kawowy",
//             "Szafka",
//             "Telewizor LCD 32 calowy z TV SAT",
//             "Duży stół dla 4-8 osób",
//             "Taras ze stołem i krzesłami"
//           ]
//         },
//         pietro: {
//           sypialnia1: [
//             "1 łóżko pojedyncze oraz jedno podwójne",
//             "Szafa",
//             "Półki i lampki nocne",
//             "Balkon z widokiem na las"
//           ],
//           sypialnia2: [
//             "3 łóżka pojedyncze",
//             "Komoda",
//             "Półki i lampki nocne"
//           ]
//         },
//         dodatkowe: "Każdy domek wyposażony w parawan na plażę, 2 leżaki oraz koc."
//       }
//     }
//   });

//   const [message, setMessage] = useState("");
//   const [imageUploading, setImageUploading] = useState({});

//   useEffect(() => {
//     const savedData = localStorage.getItem('offerData');
//     if (savedData) {
//       try {
//         const parsedData = JSON.parse(savedData);
//         setOfferData(parsedData);
//       } catch (error) {
//         console.error('Błąd parsowania danych oferty:', error);
//       }
//     }
//   }, []);

//   const saveData = () => {
//     localStorage.setItem('offerData', JSON.stringify(offerData));
//     setMessage("Zmiany zapisane pomyślnie!");
//     setTimeout(() => setMessage(""), 3000);
//   };

//   const handleImageUpload = (e, section, field) => {
//     const file = e.target.files[0];
//     if (file) {
//       setImageUploading({ ...imageUploading, [section]: true });
      
//       setTimeout(() => {
//         const reader = new FileReader();
//         reader.onload = (event) => {
//           const newImageUrl = event.target.result;
//           setOfferData({
//             ...offerData,
//             [section]: {
//               ...offerData[section],
//               [field]: newImageUrl
//             }
//           });
//           setImageUploading({ ...imageUploading, [section]: false });
//         };
//         reader.readAsDataURL(file);
//       }, 1000);
//     }
//   };

//   const handleGalleryImageUpload = (e, section, index = null) => {
//     const file = e.target.files[0];
//     if (file) {
//       const uploadKey = `${section}-gallery`;
//       setImageUploading({ ...imageUploading, [uploadKey]: true });
      
//       setTimeout(() => {
//         const reader = new FileReader();
//         reader.onload = (event) => {
//           const newImageUrl = event.target.result;
//           const newImage = { 
//             id: Date.now(), 
//             src: newImageUrl 
//           };
          
//           setOfferData({
//             ...offerData,
//             [section]: {
//               ...offerData[section],
//               galleryImages: index !== null 
//                 ? offerData[section].galleryImages.map((img, i) => i === index ? newImage : img)
//                 : [...offerData[section].galleryImages, newImage]
//             }
//           });
//           setImageUploading({ ...imageUploading, [uploadKey]: false });
//         };
//         reader.readAsDataURL(file);
//       }, 1000);
//     }
//   };

//   const removeGalleryImage = (section, index) => {
//     setOfferData({
//       ...offerData,
//       [section]: {
//         ...offerData[section],
//         galleryImages: offerData[section].galleryImages.filter((_, i) => i !== index)
//       }
//     });
//   };

//   const handleTextChange = (section, field, value) => {
//     if (section === 'general') {
//       setOfferData({
//         ...offerData,
//         [field]: value
//       });
//     } else {
//       const fieldParts = field.split('.');
//       if (fieldParts.length === 1) {
//         setOfferData({
//           ...offerData,
//           [section]: {
//             ...offerData[section],
//             [field]: value
//           }
//         });
//       } else {
//         setOfferData({
//           ...offerData,
//           [section]: {
//             ...offerData[section],
//             fullDescription: {
//               ...offerData[section].fullDescription,
//               [fieldParts[0]]: {
//                 ...offerData[section].fullDescription[fieldParts[0]],
//                 [fieldParts[1]]: value
//               }
//             }
//           }
//         });
//       }
//     }
//   };

//   // Bezpieczna funkcja do pobierania zagnieżdżonych tablic
//   const getNestedArray = (section, path) => {
//     const pathParts = path.split('.');
//     let current = offerData[section].fullDescription;
    
//     for (const part of pathParts) {
//       if (current && current[part] !== undefined) {
//         current = current[part];
//       } else {
//         return [];
//       }
//     }
    
//     return Array.isArray(current) ? current : [];
//   };

//   // Bezpieczna funkcja do aktualizacji zagnieżdżonych tablic
//   const updateNestedArray = (section, path, index, value) => {
//     const pathParts = path.split('.');
    
//     setOfferData(prevData => {
//       const newData = { ...prevData };
//       let current = newData[section].fullDescription;
      
//       for (let i = 0; i < pathParts.length - 1; i++) {
//         current = current[pathParts[i]];
//       }
      
//       const lastKey = pathParts[pathParts.length - 1];
//       const updatedArray = [...current[lastKey]];
//       updatedArray[index] = value;
//       current[lastKey] = updatedArray;
      
//       return newData;
//     });
//   };

//   // Bezpieczna funkcja do dodawania do zagnieżdżonych tablic
//   const addToNestedArray = (section, path) => {
//     const pathParts = path.split('.');
    
//     setOfferData(prevData => {
//       const newData = { ...prevData };
//       let current = newData[section].fullDescription;
      
//       for (let i = 0; i < pathParts.length - 1; i++) {
//         current = current[pathParts[i]];
//       }
      
//       const lastKey = pathParts[pathParts.length - 1];
//       current[lastKey] = [...current[lastKey], ""];
      
//       return newData;
//     });
//   };

//   // Bezpieczna funkcja do usuwania z zagnieżdżonych tablic
//   const removeFromNestedArray = (section, path, index) => {
//     const pathParts = path.split('.');
    
//     setOfferData(prevData => {
//       const newData = { ...prevData };
//       let current = newData[section].fullDescription;
      
//       for (let i = 0; i < pathParts.length - 1; i++) {
//         current = current[pathParts[i]];
//       }
      
//       const lastKey = pathParts[pathParts.length - 1];
//       current[lastKey] = current[lastKey].filter((_, i) => i !== index);
      
//       return newData;
//     });
//   };

//   const renderEditableList = (section, path, title) => {
//     const items = getNestedArray(section, path);
    
//     return (
//       <div className="mb-4">
//         <h4 className="font-semibold mb-2">{title}</h4>
//         {items.map((item, index) => (
//           <div key={index} className="flex items-center gap-2 mb-2">
//             <input
//               type="text"
//               value={item}
//               onChange={(e) => updateNestedArray(section, path, index, e.target.value)}
//               className="flex-1 p-2 border border-gray-300 rounded-md"
//             />
//             <button
//               onClick={() => removeFromNestedArray(section, path, index)}
//               className="p-2 bg-red-100 text-red-600 rounded-md"
//             >
//               <FaTrash />
//             </button>
//           </div>
//         ))}
//         <button
//           onClick={() => addToNestedArray(section, path)}
//           className="flex items-center gap-2 bg-blue-500 text-white px-3 py-1 rounded-md text-sm"
//         >
//           <FaPlus /> Dodaj pozycję
//         </button>
//       </div>
//     );
//   };

//   const renderImageUpload = (label, section, field) => (
//     <div className="mb-4">
//       <label className="block text-sm font-medium text-gray-700 mb-2">{label}</label>
//       <div className="flex items-center gap-4">
//         <div className="w-20 h-20 bg-gray-200 rounded-md overflow-hidden">
//           <img 
//             src={offerData[section][field]} 
//             alt="Podgląd" 
//             className="w-full h-full object-cover"
//           />
//         </div>
//         <label className="flex flex-col items-center justify-center w-full h-32 border-2 border-dashed border-gray-300 rounded-md cursor-pointer bg-gray-50 hover:bg-gray-100">
//           {imageUploading[section] ? (
//             <div className="flex flex-col items-center justify-center">
//               <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500 mb-2"></div>
//               <span className="text-sm">Przesyłanie...</span>
//             </div>
//           ) : (
//             <>
//               <FaUpload className="w-8 h-8 text-gray-500 mb-2" />
//               <p className="text-sm text-gray-500 text-center">
//                 <span className="font-semibold">Kliknij aby przesłać</span><br />
//                 <span className="text-xs">PNG, JPG (max. 5MB)</span>
//               </p>
//               <input 
//                 type="file" 
//                 className="hidden" 
//                 onChange={(e) => handleImageUpload(e, section, field)} 
//                 accept="image/*" 
//               />
//             </>
//           )}
//         </label>
//       </div>
//     </div>
//   );

//   return (
//     <div className="min-h-screen bg-gray-100 p-6">
//       <div className="max-w-6xl mx-auto bg-white rounded-lg shadow-md p-6">
//         <h1 className="text-2xl font-bold mb-6 text-gray-800">Panel Administracyjny - Sekcja Oferta</h1>
        
//         {message && (
//           <div className="mb-4 p-3 bg-green-100 text-green-700 rounded">
//             {message}
//           </div>
//         )}
        
//         {/* Nagłówek sekcji */}
//         <div className="mb-8 p-4 border border-gray-200 rounded-md">
//           <h2 className="text-lg font-semibold mb-3">Nagłówek sekcji</h2>
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-2">Tytuł sekcji</label>
//             <input
//               type="text"
//               value={offerData.title}
//               onChange={(e) => handleTextChange('general', 'title', e.target.value)}
//               className="w-full p-3 border border-gray-300 rounded-md"
//             />
//           </div>
//         </div>

//         {/* Domki */}
//         <div className="mb-8 p-4 border border-gray-200 rounded-md">
//           <h2 className="text-lg font-semibold mb-3">Domki 4-6 osobowe</h2>
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-2">Tytuł</label>
//             <input
//               type="text"
//               value={offerData.domki.title}
//               onChange={(e) => handleTextChange('domki', 'title', e.target.value)}
//               className="w-full p-3 border border-gray-300 rounded-md"
//             />
//           </div>
          
//           {renderImageUpload("Główne zdjęcie", "domki", "image")}
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-2">Krótki opis</label>
//             <textarea
//               value={offerData.domki.shortDescription}
//               onChange={(e) => handleTextChange('domki', 'shortDescription', e.target.value)}
//               className="w-full p-3 border border-gray-300 rounded-md h-32"
//             />
//           </div>
          
//           <div className="mb-4">
//             <h3 className="font-semibold mb-2">Galeria zdjęć</h3>
//             <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-4">
//               {offerData.domki.galleryImages.map((img, index) => (
//                 <div key={img.id} className="relative group">
//                   <img src={img.src} alt={`Domki ${index + 1}`} className="w-full h-20 object-cover rounded-md" />
//                   <button
//                     onClick={() => removeGalleryImage('domki', index)}
//                     className="absolute top-1 right-1 bg-red-500 text-white p-1 rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
//                   >
//                     <FaTrash size={12} />
//                   </button>
//                   <div className="mt-2">
//                     <label className="flex items-center justify-center w-full h-8 border border-dashed border-gray-300 rounded-md cursor-pointer bg-gray-50 hover:bg-gray-100 text-xs">
//                       Zmień
//                       <input 
//                         type="file" 
//                         className="hidden" 
//                         onChange={(e) => handleGalleryImageUpload(e, 'domki', index)} 
//                         accept="image/*" 
//                       />
//                     </label>
//                   </div>
//                 </div>
//               ))}
//             </div>
//             <label className="flex items-center justify-center w-full h-32 border-2 border-dashed border-gray-300 rounded-md cursor-pointer bg-gray-50 hover:bg-gray-100">
//               <FaPlus className="w-6 h-6 text-gray-500 mr-2" />
//               <span>Dodaj zdjęcie do galerii</span>
//               <input 
//                 type="file" 
//                 className="hidden" 
//                 onChange={(e) => handleGalleryImageUpload(e, 'domki')} 
//                 accept="image/*" 
//               />
//             </label>
//           </div>
          
//           <div className="mb-4">
//             <h3 className="font-semibold mb-2">Pełny opis</h3>
            
//             {renderEditableList('domki', 'amenities', 'Udogodnienia')}
//             {renderEditableList('domki', 'parter.kuchenny', 'Aneks kuchenny (Parter)')}
//             {renderEditableList('domki', 'parter.lazienka', 'Łazienka (Parter)')}
//             {renderEditableList('domki', 'parter.dzienny', 'Pokój dzienny (Parter)')}
            
//             <div className="mb-4">
//               <h4 className="font-semibold mb-2">Taras (Parter)</h4>
//               <input
//                 type="text"
//                 value={offerData.domki.fullDescription.parter.taras}
//                 onChange={(e) => handleTextChange('domki', 'fullDescription.parter.taras', e.target.value)}
//                 className="w-full p-2 border border-gray-300 rounded-md"
//               />
//             </div>
            
//             {renderEditableList('domki', 'pietro.sypialnia', 'Sypialnia (Piętro)')}
            
//             <div className="mb-4">
//               <h4 className="font-semibold mb-2">Dodatkowe informacje</h4>
//               <input
//                 type="text"
//                 value={offerData.domki.fullDescription.dodatkowe}
//                 onChange={(e) => handleTextChange('domki', 'fullDescription.dodatkowe', e.target.value)}
//                 className="w-full p-2 border border-gray-300 rounded-md"
//               />
//             </div>
//           </div>
//         </div>

//         {/* Apartamenty */}
//         <div className="mb-8 p-4 border border-gray-200 rounded-md">
//           <h2 className="text-lg font-semibold mb-3">Apartamenty Kolorowe Domki</h2>
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-2">Tytuł</label>
//             <input
//               type="text"
//               value={offerData.apartamenty.title}
//               onChange={(e) => handleTextChange('apartamenty', 'title', e.target.value)}
//               className="w-full p-3 border border-gray-300 rounded-md"
//             />
//           </div>
          
//           {renderImageUpload("Główne zdjęcie", "apartamenty", "image")}
          
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-2">Krótki opis</label>
//             <textarea
//               value={offerData.apartamenty.shortDescription}
//               onChange={(e) => handleTextChange('apartamenty', 'shortDescription', e.target.value)}
//               className="w-full p-3 border border-gray-300 rounded-md h-32"
//             />
//           </div>
          
//           <div className="mb-4">
//             <h3 className="font-semibold mb-2">Galeria zdjęć</h3>
//             <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-4">
//               {offerData.apartamenty.galleryImages.map((img, index) => (
//                 <div key={img.id} className="relative group">
//                   <img src={img.src} alt={`Apartamenty ${index + 1}`} className="w-full h-20 object-cover rounded-md" />
//                   <button
//                     onClick={() => removeGalleryImage('apartamenty', index)}
//                     className="absolute top-1 right-1 bg-red-500 text-white p-1 rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
//                   >
//                     <FaTrash size={12} />
//                   </button>
//                   <div className="mt-2">
//                     <label className="flex items-center justify-center w-full h-8 border border-dashed border-gray-300 rounded-md cursor-pointer bg-gray-50 hover:bg-gray-100 text-xs">
//                       Zmień
//                       <input 
//                         type="file" 
//                         className="hidden" 
//                         onChange={(e) => handleGalleryImageUpload(e, 'apartamenty', index)} 
//                         accept="image/*" 
//                       />
//                     </label>
//                   </div>
//                 </div>
//               ))}
//             </div>
//             <label className="flex items-center justify-center w-full h-32 border-2 border-dashed border-gray-300 rounded-md cursor-pointer bg-gray-50 hover:bg-gray-100">
//               <FaPlus className="w-6 h-6 text-gray-500 mr-2" />
//               <span>Dodaj zdjęcie do galerii</span>
//               <input 
//                 type="file" 
//                 className="hidden" 
//                 onChange={(e) => handleGalleryImageUpload(e, 'apartamenty')} 
//                 accept="image/*" 
//               />
//             </label>
//           </div>
          
//           <div className="mb-4">
//             <h3 className="font-semibold mb-2">Pełny opis</h3>
            
//             {renderEditableList('apartamenty', 'amenities', 'Udogodnienia')}
//             {renderEditableList('apartamenty', 'parter.kuchenny', 'Aneks kuchenny (Parter)')}
//             {renderEditableList('apartamenty', 'parter.lazienka', 'Łazienka (Parter)')}
//             {renderEditableList('apartamenty', 'parter.salon', 'Salon (Parter)')}
//             {renderEditableList('apartamenty', 'pietro.sypialnia1', 'Sypialnia 1 (Piętro)')}
//             {renderEditableList('apartamenty', 'pietro.sypialnia2', 'Sypialnia 2 (Piętro)')}
            
//             <div className="mb-4">
//               <h4 className="font-semibold mb-2">Dodatkowe informacje</h4>
//               <input
//                 type="text"
//                 value={offerData.apartamenty.fullDescription.dodatkowe}
//                 onChange={(e) => handleTextChange('apartamenty', 'fullDescription.dodatkowe', e.target.value)}
//                 className="w-full p-2 border border-gray-300 rounded-md"
//               />
//             </div>
//           </div>
//         </div>

//         {/* Zapisywanie */}
//         <div className="flex justify-end">
//           <button
//             onClick={saveData}
//             className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-medium py-2 px-4 rounded-md"
//           >
//             <FaSave /> Zapisz zmiany
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdminOfferPanel;

import React, { useState, useEffect } from 'react';
import { FaSave, FaUpload, FaPlus, FaTrash } from 'react-icons/fa';

const AdminOfferPanel = () => {
  const API_BASE = 'http://localhost/api';

  const [offerData, setOfferData] = useState({
    title: "Nasza oferta",
    domki: {
      title: "DOMKI 4-6 osobowe",
      image: "/images/oferta4.jpg",
      shortDescription: "Oferujemy Państwu piętrowe kolorowe drewniane domki, w pełni wyposażone. W domku spokojnie może zamieszkać rodzina 4-6 osobowa.",
      galleryImages: [
        { id: 1, src: '/images/oferta1.jpg' },
        { id: 2, src: '/images/oferta3.jpg' },
        { id: 3, src: '/images/oferta4.jpg' },
        { id: 4, src: '/images/oferta5.png' }
      ],
      fullDescription: {
        amenities: [
          "Parking, 1 miejsce parkingowe na domek",
          "Atrakcyjny plac zabaw dla dzieci na ogrodzonym terenie",
          "Miejsce do grillowania",
          "Internet bezprzewodowy WiFi",
          "Kijki do Nordic Walking",
          "Kojec dla dzieci - udostępniamy na życzenie Gości"
        ],
        parter: {
          kuchenny: [
            "Lodówka podblatowa",
            "Kuchenka elektryczna 2 palnikowa",
            "Mikrofalówka, czajnik",
            "Komplet garnków, patelnia",
            "Komplet talerzy i sztućców dla 6 osób",
            "Zlewozmywak"
          ],
          lazienka: [
            "Kabina prysznicowa",
            "Umywalka z szafką",
            "Kompakt WC",
            "Szafka, lustro, suszarka do włosów"
          ],
          dzienny: [
            "Sofa z funkcją spania dla 2 osób",
            "Stolik kawowy i TV",
            "Składany stolik z krzesłami",
            "Telewizor LCD 22 calowy z TV SAT",
            "Szafa"
          ],
          taras: "Taras ze stołem i krzesłami"
        },
        pietro: {
          sypialnia: [
            "2 łóżka pojedyncze oraz jedno podwójne",
            "Komoda",
            "Lampka nocna"
          ]
        },
        dodatkowe: "Każdy domek wyposażony w parawan na plażę, 2 leżaki oraz koc."
      }
    },
    apartamenty: {
      title: "APARTAMENTY KOLOROWE DOMKI",
      image: "/images/ofertadeluxe2.jpg",
      shortDescription: "Oferujemy Państwu piętrowe, komfortowe i w pełni wyposażone apartamenty z 2 sypialniami. W apartamencie może zamieszkać rodzina 4-8 osobowa.",
      galleryImages: [
        { id: 1, src: '/images/ofertadeluxe1.jpg' },
        { id: 2, src: '/images/ofertadeluxe2.jpg' },
        { id: 3, src: '/images/ofertadeluxe3.jpg' },
        { id: 4, src: '/images/ofertadeluxe4.jpg' },
        { id: 5, src: '/images/ofertadeluxe5.jpg' }
      ],
      fullDescription: {
        amenities: [
          "Parking",
          "Atrakcyjny plac zabaw dla dzieci na ogrodzonym terenie",
          "Duży teren zielony do wypoczynku z hamakami i leżakami",
          "Kameralną atmosferę, tylko 3 apartamenty na działce",
          "Miejsce do grillowania",
          "Internet bezprzewodowy WiFi",
          "Kijki do Nordic Walking",
          "Kojec dla dzieci - udostępniamy na życzenie Gości"
        ],
        parter: {
          kuchenny: [
            "Lodówka z zamrażarką",
            "Kuchenka elektryczna 4-palnikowa",
            "Zmywarka i zlewozmywak",
            "Mikrofalówka, czajnik i ekspres do kawy Tchibo Cafissimo na kapsułki",
            "Komplet garnków i patelni",
            "Komplet talerzy i sztućców dla 8 osób"
          ],
          lazienka: [
            "Kabina prysznicowa",
            "Umywalka z szafką",
            "Kompakt WC",
            "Lustro, wieszaki, suszarka do włosów"
          ],
          salon: [
            "Narożnik z funkcją spania dla 2 osób",
            "Stolik kawowy",
            "Szafka",
            "Telewizor LCD 32 calowy z TV SAT",
            "Duży stół dla 4-8 osób",
            "Taras ze stołem i krzesłami"
          ]
        },
        pietro: {
          sypialnia1: [
            "1 łóżko pojedyncze oraz jedno podwójne",
            "Szafa",
            "Półki i lampki nocne",
            "Balkon z widokiem na las"
          ],
          sypialnia2: [
            "3 łóżka pojedyncze",
            "Komoda",
            "Półki and lampki nocne"
          ]
        },
        dodatkowe: "Każdy domek wyposażony w parawan na plażę, 2 leżaki oraz koc."
      }
    }
  });

  const [message, setMessage] = useState("");
  const [imageUploading, setImageUploading] = useState({});
  const [loading, setLoading] = useState(true);

  // Załaduj dane z serwera
  useEffect(() => {
    const fetchOfferData = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${API_BASE}/offer.php`);
        
        if (!response.ok) {
          throw new Error('Błąd podczas pobierania danych');
        }
        
        const data = await response.json();
        setOfferData(data);
      } catch (error) {
        console.error('Błąd ładowania danych oferty:', error);
        setMessage('Błąd połączenia z serwerem - używam domyślnych danych');
        setTimeout(() => setMessage(""), 5000);
      } finally {
        setLoading(false);
      }
    };

    fetchOfferData();
  }, []);

  // Zapisz dane na serwerze
  const saveData = () => {
    fetch(`${API_BASE}/offer.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(offerData),
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Błąd serwera');
      }
      return response.json();
    })
    .then(data => {
      setMessage(data.message || "Zmiany zapisane pomyślnie!");
      setTimeout(() => setMessage(""), 3000);
    })
    .catch(error => {
      setMessage("Błąd podczas zapisywania danych");
      console.error('Błąd:', error);
      setTimeout(() => setMessage(""), 5000);
    });
  };

  const handleImageUpload = (e, section, field) => {
    const file = e.target.files[0];
    if (file) {
      setImageUploading({ ...imageUploading, [section]: true });
      
      const formData = new FormData();
      formData.append('image', file);
      
      fetch(`${API_BASE}/upload-offer.php`, {
        method: 'POST',
        body: formData,
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Błąd serwera');
        }
        return response.json();
      })
      .then(data => {
        if (data.success) {
          const imageUrl = data.url.startsWith('http') ? data.url : `http://localhost${data.url}`;
          setOfferData({
            ...offerData,
            [section]: {
              ...offerData[section],
              [field]: imageUrl
            }
          });
          setMessage("Obrazek przesłany pomyślnie!");
        } else {
          setMessage(data.error || "Błąd podczas przesyłania obrazka");
        }
        setImageUploading({ ...imageUploading, [section]: false });
        setTimeout(() => setMessage(""), 3000);
      })
      .catch(error => {
        setMessage("Błąd podczas przesyłania obrazka");
        setImageUploading({ ...imageUploading, [section]: false });
        setTimeout(() => setMessage(""), 5000);
      });
    }
  };

  const handleGalleryImageUpload = (e, section, index = null) => {
    const file = e.target.files[0];
    if (file) {
      const uploadKey = `${section}-gallery`;
      setImageUploading({ ...imageUploading, [uploadKey]: true });
      
      const formData = new FormData();
      formData.append('image', file);
      
      fetch(`${API_BASE}/upload-offer.php`, {
        method: 'POST',
        body: formData,
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Błąd serwera');
        }
        return response.json();
      })
      .then(data => {
        if (data.success) {
          const imageUrl = data.url.startsWith('http') ? data.url : `http://localhost${data.url}`;
          const newImage = { 
            id: Date.now(), 
            src: imageUrl 
          };
          
          setOfferData({
            ...offerData,
            [section]: {
              ...offerData[section],
              galleryImages: index !== null 
                ? offerData[section].galleryImages.map((img, i) => i === index ? newImage : img)
                : [...offerData[section].galleryImages, newImage]
            }
          });
          setMessage("Obrazek galerii przesłany pomyślnie!");
        } else {
          setMessage(data.error || "Błąd podczas przesyłania obrazka galerii");
        }
        setImageUploading({ ...imageUploading, [uploadKey]: false });
        setTimeout(() => setMessage(""), 3000);
      })
      .catch(error => {
        setMessage("Błąd podczas przesyłania obrazka galerii");
        setImageUploading({ ...imageUploading, [uploadKey]: false });
        setTimeout(() => setMessage(""), 5000);
      });
    }
  };

  const removeGalleryImage = (section, index) => {
    setOfferData({
      ...offerData,
      [section]: {
        ...offerData[section],
        galleryImages: offerData[section].galleryImages.filter((_, i) => i !== index)
      }
    });
  };

  const handleTextChange = (section, field, value) => {
    if (section === 'general') {
      setOfferData({
        ...offerData,
        [field]: value
      });
    } else {
      const fieldParts = field.split('.');
      if (fieldParts.length === 1) {
        setOfferData({
          ...offerData,
          [section]: {
            ...offerData[section],
            [field]: value
          }
        });
      } else {
        setOfferData({
          ...offerData,
          [section]: {
            ...offerData[section],
            fullDescription: {
              ...offerData[section].fullDescription,
              [fieldParts[0]]: {
                ...offerData[section].fullDescription[fieldParts[0]],
                [fieldParts[1]]: value
              }
            }
          }
        });
      }
    }
  };

  // Bezpieczna funkcja do pobierania zagnieżdżonych tablic
  const getNestedArray = (section, path) => {
    const pathParts = path.split('.');
    let current = offerData[section].fullDescription;
    
    for (const part of pathParts) {
      if (current && current[part] !== undefined) {
        current = current[part];
      } else {
        return [];
      }
    }
    
    return Array.isArray(current) ? current : [];
  };

  // Bezpieczna funkcja do aktualizacji zagnieżdżonych tablic
  const updateNestedArray = (section, path, index, value) => {
    const pathParts = path.split('.');
    
    setOfferData(prevData => {
      const newData = { ...prevData };
      let current = newData[section].fullDescription;
      
      for (let i = 0; i < pathParts.length - 1; i++) {
        current = current[pathParts[i]];
      }
      
      const lastKey = pathParts[pathParts.length - 1];
      const updatedArray = [...current[lastKey]];
      updatedArray[index] = value;
      current[lastKey] = updatedArray;
      
      return newData;
    });
  };

  // Bezpieczna funkcja do dodawania do zagnieżdżonych tablic
  const addToNestedArray = (section, path) => {
    const pathParts = path.split('.');
    
    setOfferData(prevData => {
      const newData = { ...prevData };
      let current = newData[section].fullDescription;
      
      for (let i = 0; i < pathParts.length - 1; i++) {
        current = current[pathParts[i]];
      }
      
      const lastKey = pathParts[pathParts.length - 1];
      current[lastKey] = [...current[lastKey], ""];
      
      return newData;
    });
  };

  // Bezpieczna funkcja do usuwania z zagnieżdżonych tablic
  const removeFromNestedArray = (section, path, index) => {
    const pathParts = path.split('.');
    
    setOfferData(prevData => {
      const newData = { ...prevData };
      let current = newData[section].fullDescription;
      
      for (let i = 0; i < pathParts.length - 1; i++) {
        current = current[pathParts[i]];
      }
      
      const lastKey = pathParts[pathParts.length - 1];
      current[lastKey] = current[lastKey].filter((_, i) => i !== index);
      
      return newData;
    });
  };

  const renderEditableList = (section, path, title) => {
    const items = getNestedArray(section, path);
    
    return (
      <div className="mb-4">
        <h4 className="font-semibold mb-2">{title}</h4>
        {items.map((item, index) => (
          <div key={index} className="flex items-center gap-2 mb-2">
            <input
              type="text"
              value={item}
              onChange={(e) => updateNestedArray(section, path, index, e.target.value)}
              className="flex-1 p-2 border border-gray-300 rounded-md"
            />
            <button
              onClick={() => removeFromNestedArray(section, path, index)}
              className="p-2 bg-red-100 text-red-600 rounded-md"
            >
              <FaTrash />
            </button>
          </div>
        ))}
        <button
          onClick={() => addToNestedArray(section, path)}
          className="flex items-center gap-2 bg-blue-500 text-white px-3 py-1 rounded-md text-sm"
        >
          <FaPlus /> Dodaj pozycję
        </button>
      </div>
    );
  };

  const renderImageUpload = (label, section, field) => (
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700 mb-2">{label}</label>
      <div className="flex items-center gap-4">
        <div className="w-20 h-20 bg-gray-200 rounded-md overflow-hidden">
          <img 
            src={offerData[section][field]} 
            alt="Podgląd" 
            className="w-full h-full object-cover"
            onError={(e) => {
              e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZGRkIi8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtc2l6ZT0iMTIiIGR5PSIuM2VtIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSIjOTk5Ij5CxIVkIGxhdG93YW5pYSBvYnJhesSFa2E8L3RleHQ+PC9zdmc+';
            }}
          />
        </div>
        <label className="flex flex-col items-center justify-center w-full h-32 border-2 border-dashed border-gray-300 rounded-md cursor-pointer bg-gray-50 hover:bg-gray-100">
          {imageUploading[section] ? (
            <div className="flex flex-col items-center justify-center">
              <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500 mb-2"></div>
              <span className="text-sm">Przesyłanie...</span>
            </div>
          ) : (
            <>
              <FaUpload className="w-8 h-8 text-gray-500 mb-2" />
              <p className="text-sm text-gray-500 text-center">
                <span className="font-semibold">Kliknij aby przesłać</span><br />
                <span className="text-xs">PNG, JPG (max. 5MB)</span>
              </p>
              <input 
                type="file" 
                className="hidden" 
                onChange={(e) => handleImageUpload(e, section, field)} 
                accept="image/*" 
              />
            </>
          )}
        </label>
      </div>
    </div>
  );

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-100 p-6">
        <div className="max-w-6xl mx-auto bg-white rounded-lg shadow-md p-6">
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="max-w-6xl mx-auto bg-white rounded-lg shadow-md p-6">
        <h1 className="text-2xl font-bold mb-6 text-gray-800">Panel Administracyjny - Sekcja Oferta</h1>
        
        {message && (
          <div className={`mb-4 p-3 rounded ${
            message.includes('Błąd') ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'
          }`}>
            {message}
          </div>
        )}
        
        {/* Nagłówek sekcji */}
        <div className="mb-8 p-4 border border-gray-200 rounded-md">
          <h2 className="text-lg font-semibold mb-3">Nagłówek sekcji</h2>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">Tytuł sekcji</label>
            <input
              type="text"
              value={offerData.title}
              onChange={(e) => handleTextChange('general', 'title', e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-md"
            />
          </div>
        </div>

        {/* Domki */}
        <div className="mb-8 p-4 border border-gray-200 rounded-md">
          <h2 className="text-lg font-semibold mb-3">Domki 4-6 osobowe</h2>
          
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">Tytuł</label>
            <input
              type="text"
              value={offerData.domki.title}
              onChange={(e) => handleTextChange('domki', 'title', e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-md"
            />
          </div>
          
          {renderImageUpload("Główne zdjęcie", "domki", "image")}
          
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">Krótki opis</label>
            <textarea
              value={offerData.domki.shortDescription}
              onChange={(e) => handleTextChange('domki', 'shortDescription', e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-md h-32"
            />
          </div>
          
          <div className="mb-4">
            <h3 className="font-semibold mb-2">Galeria zdjęć</h3>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-4">
              {offerData.domki.galleryImages.map((img, index) => (
                <div key={img.id} className="relative group">
                  <img 
                    src={img.src} 
                    alt={`Domki ${index + 1}`} 
                    className="w-full h-20 object-cover rounded-md"
                    onError={(e) => {
                      e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZGRkIi8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtc2l6ZT0iMTIiIGR5PSIuM2VtIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSIjOTk5Ij5CxIVkIGxhdG93YW5pYSBvYnJhesSFa2E8L3RleHQ+PC9zdmc+';
                    }}
                  />
                  <button
                    onClick={() => removeGalleryImage('domki', index)}
                    className="absolute top-1 right-1 bg-red-500 text-white p-1 rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
                  >
                    <FaTrash size={12} />
                  </button>
                  <div className="mt-2">
                    <label className="flex items-center justify-center w-full h-8 border border-dashed border-gray-300 rounded-md cursor-pointer bg-gray-50 hover:bg-gray-100 text-xs">
                      Zmień
                      <input 
                        type="file" 
                        className="hidden" 
                        onChange={(e) => handleGalleryImageUpload(e, 'domki', index)} 
                        accept="image/*" 
                      />
                    </label>
                  </div>
                </div>
              ))}
            </div>
            <label className="flex items-center justify-center w-full h-32 border-2 border-dashed border-gray-300 rounded-md cursor-pointer bg-gray-50 hover:bg-gray-100">
              <FaPlus className="w-6 h-6 text-gray-500 mr-2" />
              <span>Dodaj zdjęcie do galerii</span>
              <input 
                type="file" 
                className="hidden" 
                onChange={(e) => handleGalleryImageUpload(e, 'domki')} 
                accept="image/*" 
              />
            </label>
          </div>
          
          <div className="mb-4">
            <h3 className="font-semibold mb-2">Pełny opis</h3>
            
            {renderEditableList('domki', 'amenities', 'Udogodnienia')}
            {renderEditableList('domki', 'parter.kuchenny', 'Aneks kuchenny (Parter)')}
            {renderEditableList('domki', 'parter.lazienka', 'Łazienka (Parter)')}
            {renderEditableList('domki', 'parter.dzienny', 'Pokój dzienny (Parter)')}
            
            <div className="mb-4">
              <h4 className="font-semibold mb-2">Taras (Parter)</h4>
              <input
                type="text"
                value={offerData.domki.fullDescription.parter.taras || ''}
                onChange={(e) => handleTextChange('domki', 'fullDescription.parter.taras', e.target.value)}
                className="w-full p-2 border border-gray-300 rounded-md"
              />
            </div>
            
            {renderEditableList('domki', 'pietro.sypialnia', 'Sypialnia (Piętro)')}
            
            <div className="mb-4">
              <h4 className="font-semibold mb-2">Dodatkowe informacje</h4>
              <input
                type="text"
                value={offerData.domki.fullDescription.dodatkowe || ''}
                onChange={(e) => handleTextChange('domki', 'fullDescription.dodatkowe', e.target.value)}
                className="w-full p-2 border border-gray-300 rounded-md"
              />
            </div>
          </div>
        </div>

        {/* Apartamenty */}
        <div className="mb-8 p-4 border border-gray-200 rounded-md">
          <h2 className="text-lg font-semibold mb-3">Apartamenty Kolorowe Domki</h2>
          
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">Tytuł</label>
            <input
              type="text"
              value={offerData.apartamenty.title}
              onChange={(e) => handleTextChange('apartamenty', 'title', e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-md"
            />
          </div>
          
          {renderImageUpload("Główne zdjęcie", "apartamenty", "image")}
          
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">Krótki opis</label>
            <textarea
              value={offerData.apartamenty.shortDescription}
              onChange={(e) => handleTextChange('apartamenty', 'shortDescription', e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-md h-32"
            />
          </div>
          
          <div className="mb-4">
            <h3 className="font-semibold mb-2">Galeria zdjęć</h3>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-4">
              {offerData.apartamenty.galleryImages.map((img, index) => (
                <div key={img.id} className="relative group">
                  <img 
                    src={img.src} 
                    alt={`Apartamenty ${index + 1}`} 
                    className="w-full h-20 object-cover rounded-md"
                    onError={(e) => {
                      e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVctdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZGRkIi8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtc2l6ZT0iMTIiIGR5PSIuM2VtIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSIjOTk5Ij5CxIVkIGxhdG93YW5pYSBvYnJhesSFa2E8L3RleHQ+PC9zdmc+';
                    }}
                  />
                  <button
                    onClick={() => removeGalleryImage('apartamenty', index)}
                    className="absolute top-1 right-1 bg-red-500 text-white p-1 rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
                  >
                    <FaTrash size={12} />
                  </button>
                  <div className="mt-2">
                    <label className="flex items-center justify-center w-full h-8 border border-dashed border-gray-300 rounded-md cursor-pointer bg-gray-50 hover:bg-gray-100 text-xs">
                      Zmień
                      <input 
                        type="file" 
                        className="hidden" 
                        onChange={(e) => handleGalleryImageUpload(e, 'apartamenty', index)} 
                        accept="image/*" 
                      />
                    </label>
                  </div>
                </div>
              ))}
            </div>
            <label className="flex items-center justify-center w-full h-32 border-2 border-dashed border-gray-300 rounded-md cursor-pointer bg-gray-50 hover:bg-gray-100">
              <FaPlus className="w-6 h-6 text-gray-500 mr-2" />
              <span>Dodaj zdjęcie do galerii</span>
              <input 
                type="file" 
                className="hidden" 
                onChange={(e) => handleGalleryImageUpload(e, 'apartamenty')} 
                accept="image/*" 
              />
            </label>
          </div>
          
          <div className="mb-4">
            <h3 className="font-semibold mb-2">Pełny opis</h3>
            
            {renderEditableList('apartamenty', 'amenities', 'Udogodnienia')}
            {renderEditableList('apartamenty', 'parter.kuchenny', 'Aneks kuchenny (Parter)')}
            {renderEditableList('apartamenty', 'parter.lazienka', 'Łazienka (Parter)')}
            {renderEditableList('apartamenty', 'parter.salon', 'Salon (Parter)')}
            {renderEditableList('apartamenty', 'pietro.sypialnia1', 'Sypialnia 1 (Piętro)')}
            {renderEditableList('apartamenty', 'pietro.sypialnia2', 'Sypialnia 2 (Piętro)')}
            
            <div className="mb-4">
              <h4 className="font-semibold mb-2">Dodatkowe informacje</h4>
              <input
                type="text"
                value={offerData.apartamenty.fullDescription.dodatkowe || ''}
                onChange={(e) => handleTextChange('apartamenty', 'fullDescription.dodatkowe', e.target.value)}
                className="w-full p-2 border border-gray-300 rounded-md"
              />
            </div>
          </div>
        </div>

        {/* Zapisywanie */}
        <div className="flex justify-end">
          <button
            onClick={saveData}
            className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-medium py-2 px-4 rounded-md"
          >
            <FaSave /> Zapisz zmiany
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminOfferPanel;